import React, { useContext } from 'react'
import { breakpoints, Text, View } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { InboxGlyph16Icon } from 'assets/icons'
import { LAYOUT_HEADER, LAYOUT_SIDEBAR } from 'config/constants/ui'
import LayoutContainerFixedArea from 'src/apps/CustomApp/components/LayoutContainerFixedArea'
import Title from 'src/apps/CustomApp/components/Title'
import ListMenuButton from 'src/apps/Global/components/ListMenuButton'
import NotFound from 'src/apps/Global/apps/NotFound'
import { useMe, useMyDirectThreadList, useMyNotificationCount } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import Inbox from './apps/Inbox'
import ThreadChatView from '~/apps/ThreadChatView'

const Messages = () => {
   const match = useRouteMatch()
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const initialSizeIsMobile = window.innerWidth < breakpoints.b

   const { notificationCount } = useMyNotificationCount()
   const { myDirectThreadList } = useMyDirectThreadList()
   const { isLoggedIn, networkStatus } = useMe()
   const initialLoading = networkStatus <= 2

   const isHeaderGL = theme.tmpGlobalLayout === LAYOUT_HEADER
   const isSidebarGL = theme.tmpGlobalLayout === LAYOUT_SIDEBAR

   const menuWidth = isSidebarGL
      ? '100vw[a-b] 33vw[c] 300px[d] 330px[e-f]'
      : '100vw[a-b] 33vw[c] 300px[d] 330px[e-f]'

   let contentOffset = '0[a-b] 33vw[c] 300px[d] 330px[e-f]'

   if (isHeaderGL) {
      contentOffset = `0[a-b]
         calc(33vw + ${theme.tmpViewportPaddingC})[c]
         calc(300px + ${theme.tmpViewportPaddingD})[d]
         calc(330px + ${theme.tmpViewportPaddingE})[e]
         calc(330px + ${theme.tmpViewportPaddingF})[f]`
   }

   const buttonProps = {
      activeBackgroundColor: theme.tmpAsideButtonActiveBackgroundColor,
      activeTextColor: theme.tmpAsideButtonActiveTextColor,
      borderStyle: `1px solid ${theme.tmpAsideLineColor}`,
      textColor: theme.tmpAsideButtonTextColor,
      textSize: theme.tmpSecondaryButtonTextSize
   }

   // TODO: This should probably go to some kind of Unauthorized component instead
   if (!initialLoading && !isLoggedIn) {
      return <NotFound />
   }

   if (initialLoading) {
      return null
   }

   return (
      <LayoutContainerFixedArea>
         <View
            float="left"
            height="100%"
            paddingLeft={isHeaderGL && theme.tmpViewportPadding}
            scroll="on">
            <View
               float="left"
               width={menuWidth}
               height="100%"
               paddingLeft={!isHeaderGL && '30px'}
               backgroundColor={!isHeaderGL && theme.tmpContentBackgroundColor}
               paddingRight={`
                  ${theme.tmpViewportPaddingA}[a]
                  ${theme.tmpViewportPaddingB}[b]
                  15px[c-f]
               `}
               borderRight={`1px solid ${theme.tmpColumnBorderColor}[c-f]`}>
               <View
                  paddingVertical={theme.tmpSpacingTop}
                  width="100%">
                  <Title size="md">Messages</Title>
               </View>
               <ListMenuButton
                  icon={(
                     <View
                        display="flex"
                        alignItems="center"
                        style={{ opacity: '0.5' }}>
                        <InboxGlyph16Icon
                           width="14px"
                           height="14px"
                           color={theme.tmpAsideButtonTextColor}
                        />
                     </View>
                  )}
                  linkExact
                  linkTo={`${match.url}/inbox`}
                  name="Inbox"
                  showBadge={notificationCount > 0}
                  {...buttonProps}
               />
               {myDirectThreadList.items.map(thread => (
                  <ListMenuButton
                     key={thread.id}
                     icon={(
                        <View
                           flex="0 0 auto"
                           display="flex"
                           flexFlow="column"
                           height="14px"
                           width="14px"
                           justifyContent="center"
                           alignItems="center"
                           transition="300ms"
                           backgroundColor="#aaa"
                           borderRadius="3px">
                           <Text
                              size="0.8"
                              weight="bold"
                              color="#fff"
                              style={{ transition: '300ms' }}>
                              {thread.title.charAt(0)}
                           </Text>
                        </View>
                     )}
                     linkTo={`${match.url}/direct/${thread.id}`}
                     name={thread.title}
                     showBadge={thread.hasUnreadEntries}
                     {...buttonProps}
                  />
               ))}
            </View>
         </View>
         <Switch>
            {!initialSizeIsMobile && (
               <Redirect exact from={match.url} to={`${match.url}/inbox`} />
            )}
            <Route
               path={[
                  `${match.path}/inbox`,
                  `${match.path}/direct/:threadId`
               ]}>
               <View
                  position="absolute"
                  top="0px"
                  left={contentOffset}
                  right="0px"
                  bottom="0px"
                  style={{
                     borderTopRightRadius: theme.tmpBorderRadius,
                     borderBottomRightRadius: theme.tmpBorderRadius,
                     overflow: 'hidden'
                  }}>
                  <Switch>
                     <Route path={`${match.path}/inbox`} component={Inbox} />
                     <Route
                        path={`${match.path}/direct/:threadId`}
                        component={ThreadChatView}
                     />
                  </Switch>
               </View>
            </Route>
         </Switch>
      </LayoutContainerFixedArea>
   )
}

export default Messages
